import React from 'react';

export default function Verification() {
  return (
    <div className="bg-white min-h-screen py-12 px-4">
      <div className="space-y-16">

        {/* Header */}
        <div className="text-center space-y-4">
          <h1 className="text-4xl font-extrabold text-purple-700 text-center">
            Million2Trillion — Verification & Trust Process
          </h1>
          <p className="text-lg text-gray-700">
            Our multi-layer system protects every professional inside the ecosystem.
          </p>
        </div>

        {/* Verification Layers Card */}
        <div className="max-w-5xl mx-auto border border-purple-200 bg-white p-10 rounded-2xl shadow-xl">
          <h2 className="text-3xl font-bold text-purple-600 text-center mb-6">Verification Layers</h2>
          <ul className="list-disc space-y-5 text-gray-800 text-lg px-6">
            <li><strong className="text-green-600">Identity Verification:</strong> Government ID checks, address proof, phone verification.</li>
            <li><strong className="text-green-600">Role-Based Qualification:</strong> Proof of experience, certification uploads, trading statements, audit reports.</li>
            <li><strong className="text-green-600">Skill Proof Layer:</strong> Education certificates, licenses, past work verification for mentors, educators, legal & advisory professionals.</li>
            <li><strong className="text-green-600">Continuous Behavior Monitoring:</strong> Platform-integrated complaint handling, dispute system, violation detection.</li>
            <li><strong className="text-green-600">Re-verification & KYC Refresh:</strong> Periodic updates of KYC to maintain compliance with local & international laws.</li>
          </ul>
        </div>


      </div>
    </div>
  );
}
